import { useTranslation } from "react-i18next";
import { formatIssueRange } from "./newsletterFormat";

function record(tally) {
  return `${Number(tally?.wins) || 0}–${Number(tally?.losses) || 0}`;
}

export function NewsletterMonthStrip({ month }) {
  const { t, i18n } = useTranslation();
  if (!month) return null;
  const figures = [
    [month.sessions || 0, t("newsletterScoreSessions", "Sessions")],
    [record(month.league), t("newsletterLeagueRecord", "League W–L")],
    [record(month.cup), t("newsletterCupRecord", "Cup W–L")],
    [month.podiums || 0, t("newsletterPodiums", "Podiums")],
    [month.best_rally || 0, t("newsletterScoreRally", "Best rally")],
  ];
  return (
    <section className="pingflo-section pingflo-month">
      <h2>
        {t("newsletterMonth", "Month so far")}
        <span className="pingflo-quiet"> · {formatIssueRange(month.start, month.end, i18n.language)}</span>
      </h2>
      <ol className="pingflo-month-strip">
        {figures.map(([value, label]) => (
          <li key={label}>
            <strong>{value}</strong>
            <span>{label}</span>
          </li>
        ))}
      </ol>
      {month.best_rally_name ? (
        <p className="pingflo-quiet">
          {t("newsletterScoreRally", "Best rally")}: {month.best_rally_name}
        </p>
      ) : null}
      {month.top_attendees?.length ? (
        <p className="pingflo-quiet">
          {t("newsletterMostPresent", "Most present")}:{" "}
          {month.top_attendees.map((p) => p.name).join(" · ")}
        </p>
      ) : null}
    </section>
  );
}
